import uploadsaboutUspagebannerbgimageaboutusbannerJpg from "$lib/data/generated/uploads/about us/PageBanner/bgImage/AboutUsBanner.jpg";

export const uploads = {
  "uploads/about us/PageBanner/bgImage/AboutUsBanner.jpg": uploadsaboutUspagebannerbgimageaboutusbannerJpg
};